import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { ClientSummary } from '../../2_domain/client/client';
import IClientRepository from '../../2_domain/client/iClientRepository';
import Get from '../../lib/di/get';
import promiseResolver from '../../lib/util/promiseResolver';

const emptyPagination: Pagination = {
  isAscending: false,
  pageNumber: 0,
  pageSize: 20,
};

const emptyPageResult: Page = {
  totalElements: 0,
  pageNumber: 0,
};

let timer: NodeJS.Timeout | undefined;

const useTestAddClientSelectListController = () => {
  const navigate = useNavigate();
  const clientRepo = Get.find<IClientRepository>('IClientRepository');
  const [searchText, setSearchText] = useState('');
  const [clients, setClient] = useState<ClientSummary[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState(emptyPagination);
  const [pageResult, setPageResult] = useState(emptyPageResult);

  const addNewClientHandler = async () => {
    navigate('../../patient/add');
  };

  const setPageNumber = (newPageNumber: number) => {
    setPagination((prev) => {
      return { ...prev, pageNumber: newPageNumber };
    });
  };

  const setPageSize = (newPageSize: number) => {
    setPagination((prev) => {
      return { ...prev, pageSize: newPageSize };
    });
  };

  const searchClients = () => {
    promiseResolver({
      promise: clientRepo.getClients({ searchText, pagination }),
      successCallback: (data) => {
        setPageResult(data.page);
        setClient(data.list);
      },
      isLoadingCallback: setIsLoading,
    });
  };

  useEffect(() => {
    searchClients();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination]);

  useEffect(() => {
    setIsLoading(true);
    clearTimeout(timer);
    timer = setTimeout(searchClients, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  return {
    addNewClientHandler,
    searchText,
    setSearchText,
    clients,
    isLoading,
    pagination,
    pageResult,
    setPageNumber,
    setPageSize,
  };
};

export default useTestAddClientSelectListController;
